import { ButtonBase, makeStyles } from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'
import clsx from 'clsx'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    overflowX: 'auto',
    padding: 4,
    borderRadius: 8,
    border: `1px solid ${GRAY_COLORS[100]}`,
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  },
  buttonBase: {
    padding: '8px 12px',
    display: 'flex',
    gap: 6,
    color: GRAY_COLORS[500],
    borderRadius: 6,
    whiteSpace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px'
  },
  active: {
    color: GRAY_COLORS[700],
    backgroundColor: BASE_COLORS.White
  },
  chip: {
    padding: '2px 8px',
    borderRadius: 12,
    backgroundColor: GRAY_COLORS[50],
    color: GRAY_COLORS[700],
    border: `1px solid ${GRAY_COLORS[200]}`,
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 500
  }
}))

export const ButtonTabsContainer = ({ children }) => {
  const classes = useStyle()
  const maxWidth = window.innerWidth - 16
  return (
    <div className={classes.rootDiv} style={{ maxWidth }}>
      {children}
    </div>
  )
}

export const ButtonTab = ({
  children,
  onClick = () => {},
  isActive,
  ...props
}) => {
  const classes = useStyle()
  return (
    <ButtonBase
      className={clsx(classes.buttonBase, isActive && classes.active)}
      onClick={onClick}
      {...props}
    >
      {children}
    </ButtonBase>
  )
}
